// Auth provider configuration
import { AUTH_PROVIDERS } from '@/consts/auth.consts';
import { isFigmaEmbedRoute, isInsideIframe } from '@/utils/auth.utils';
import type { AuthProvider } from '@/services/auth/authProvider.types';

interface DescopeConfig {
  projectId: string;
}

interface AuthConfig {
  config?: DescopeConfig;
  provider: AuthProvider;
}

export const useAuthConfig = (): AuthConfig => {
  if (isFigmaEmbedRoute() && isInsideIframe()) {
    return {
      provider: AUTH_PROVIDERS.FIGMA_EMBED,
    };
  }
  return {
    provider: AUTH_PROVIDERS.FIREBASE,
  };
};
